export default "__VITE_ASSET__1f8e58c6__"